var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('result-list',{on:{"handleClickItem":_vm.handleClickItem,"handleClickRegister":_vm.handleClickRegister}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }